import React from "react";
import AltInicioSlider from "../AltInicioSlider";
import "../../../scss/dashboard/dashInicio.css";
function AltIndexBoxThree() {
  return (
    <div className="inicio__box-slider altInicio-slider">
      <div className="altInicio-slider__h4">
        <h4>Movimiento Mensual</h4>
      </div>
      <div>
        <AltInicioSlider />
      </div>
    </div>
  );
}

export default AltIndexBoxThree;
